module.exports = __webpack_public_path__ + "static/media/algae7.f6fe25d4.svg";